// Mock data for HOA Newsletter Generator
// NOTE: Content fields are empty - users must provide all content

export const mockUser = {
  user_id: 'user_123456789abc',
  email: 'user@example.com',
  name: 'User',
  picture: '',
  newsletters_this_month: 0,
  last_newsletter_date: null,
};

export const mockNewsletterLimit = {
  used: 0,
  limit: 2,
  reset_date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
  can_create: true,
};

export const mockTemplates = [
  {
    id: 'riverwood',
    name: 'Riverwood Newsletter',
    description: 'The official Riverwood Coop Board newsletter template.',
    customizable: false,
    sections: ['header', 'introductions', 'from_the_board', 'housekeeping_rules'],
  },
  {
    id: 'sample1',
    name: 'Sample 1',
    description: 'Community association newsletter template.',
    customizable: true,
    sections: ['officers', 'directors', 'calendar', 'events', 'contact'],
  },
  {
    id: 'sample2',
    name: 'Sample 2',
    description: 'Quarterly update newsletter template.',
    customizable: true,
    sections: ['market_summary', 'stats', 'forecast', 'trends', 'contact'],
  },
  {
    id: 'newsletter_2022',
    name: 'Newsletter 2022',
    description: 'Community newsletter template.',
    customizable: true,
    sections: ['from_board', 'from_manager', 'community', 'calendar', 'contacts'],
  },
  {
    id: 'custom',
    name: 'Custom Template',
    description: 'Upload your own PDF template to customize.',
    customizable: true,
    sections: ['custom'],
  },
];

// Riverwood template structure - ALL FIELDS EMPTY for user to fill
export const mockRiverwoodSections = {
  header: {
    title: '',
    subtitle: '',
    edition: '',
  },
  introductions: {
    title: '',
    body: '',
    board: [
      { role: 'President', name: '' },
      { role: 'Vice President', name: '' },
      { role: 'Secretary', name: '' },
      { role: 'Treasurer', name: '' },
      { role: 'Member at Large', name: '' },
      { role: 'Member at Large', name: '' },
    ],
    staff: [
      { role: 'Superintendent', name: '' },
      { role: 'Porter', name: '' },
    ],
    management: { role: 'Managing Agent', name: '' },
  },
  from_the_board: {
    title: 'From the Board:',
    body: '',
  },
  housekeeping_rules: {
    title: 'Housekeeping/House Rules Reminders',
    rules: [],
  },
};

// The actual Riverwood header image URL from user's uploaded file
export const RIVERWOOD_HEADER_IMAGE = 'https://customer-assets.emergentagent.com/job_riverwood-press/artifacts/tfoi2rzr_Screenshot%202025-12-11%20161633.png';

export const mockSavedNewsletters = [];
